export const Base = require("./Base.vue").default;

export const routes = [
  {
    path: "",
    component: require("./Base.vue").default,  
    meta: { allowedRoles: ["*"] },
    name: "support_ticket",
  }
];